import { Table, Td, Tr } from 'app/common/ui-components/table'

import styles from './Consist.scss'


type Props = {
  dishItems: Array<{
    id: number
    index: number
    portion: string
    title: string
  }>
}

export const Consist = ({ dishItems }: Props) => {
  return (
    <Table className={styles.root}>
      <tbody>
        {dishItems.map(({ id, portion, title }) => (
          <Tr key={id}>
            <Td alignLeft stripStyles>{title}</Td>
            <Td alignRight stripStyles>{portion}</Td>
          </Tr>
        ))}
      </tbody>
    </Table>
  )
}
